import { action, Action, persist } from 'easy-peasy';

export interface SupportInfoPopupModel {
  supportInfoDialogOpen: boolean;
  setSupportInfoDialogOpen: Action<SupportInfoPopupModel, boolean>;
  supportInfoDialogShouldOpenAgainAt: string;
  setSupportInfoDialogShouldOpenAgainAt: Action<SupportInfoPopupModel, string>;
  supportTicketModalOpen: boolean;
  setSupportTicketModalOpen: Action<SupportInfoPopupModel, boolean>;
}

const supportInfoPopupModel: SupportInfoPopupModel = {
  supportInfoDialogOpen: true,
  setSupportInfoDialogOpen: action((state, payload) => {
    state.supportInfoDialogOpen = payload;
  }),
  supportInfoDialogShouldOpenAgainAt: '',
  setSupportInfoDialogShouldOpenAgainAt: action((state, payload) => {
    state.supportInfoDialogShouldOpenAgainAt = payload;
  }),
  supportTicketModalOpen: false,
  setSupportTicketModalOpen: action((state, payload) => {
    state.supportTicketModalOpen = payload;
  }),
};

export default persist(supportInfoPopupModel, {
  allow: ['supportInfoDialogOpen', 'supportInfoDialogShouldOpenAgainAt'],
  storage: 'localStorage',
});
